import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBoxCenter, FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { ReactComponent as Question } from '@ecp/common/src/assets/icon/icon-question.svg';

import { ReactComponent as Exclamation } from '@mo-assets/image/common/icon/icon_exclamation_mark.svg';

export const MainContentsTitleBox = styled(FlexBox)`
  justify-content: space-between;
  align-items: flex-end;
`;

export const MainContentsTitle = styled(TextBox)`
  font-weight: ${moTheme.font.weight.bold};
  font-size: ${moTheme.font.size.$16};
  line-height: ${moTheme.font.lineHeight.demiLight};
  color: ${(props) => props.theme.color.text.basic};
  word-break: keep-all;
`;

export const QuestionIcon = styled(Question)`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const ExclamationIcon = styled(Exclamation)`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const CircleWrapper = styled(FlexBoxCenter)`
  width: 40px;
  height: 40px;
  border: 1px solid ${(props) => props.theme.color.line.line02};
  border-radius: 50%;
  cursor: pointer;
  background-color: ${(props) => props.theme.color.background.white};
  overflow: hidden;
  position: relative;
`;
